import script from "./CMChessboard.vue?vue&type=script&setup=true&lang=js"
export * from "./CMChessboard.vue?vue&type=script&setup=true&lang=js"

import "./CMChessboard.vue?vue&type=style&index=0&id=44fed615&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44fed615"]])

export default __exports__